import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'environments/environment';

@Pipe({
    name: 'fileServerUrl',
    standalone: false
})
export class FileServerUrlPipe implements PipeTransform {


  transform(document: string | string[], key?: string): string | string[] {
    if (typeof (document) === 'string') {
      return this.formatUrl(document, key);
    } else if (document !== undefined && document !== null) {
      return (document as string[]).map(d => this.formatUrl(d, key));
    }
    return undefined;
  }

  private formatUrl(document: string, format: string): string {
    if (document) {
      if (document.startsWith('/')) {
        if (format) {
          return environment.image_server + `/api/v1/images/${document.split('/')[2]}` + `.${format}`;
        } else {
          return environment.image_server + `/api/v1/images/${document.split('/')[2]}`;
        }
      } else {
        if (format) {
          return environment.image_server + `/api/v1/images/${document}` + `.${format}`;
        } else {
          return environment.image_server + `/api/v1/images/${document}`;
        }
      }
    } else {
      return undefined;
    }
  }
}
